import { AnyFluxStandardAction } from "core/utils/redux";
import { ChartInterface } from "elementInterfaces";

export function buildInterface(refreshAction: () => AnyFluxStandardAction) {
  return ChartInterface.implement({
    refresh: refreshAction,
  });
}
